export default "__VITE_ASSET__pw87wuPa__"